import { Service } from "@roc/feature-app-core";

const url = {
  GET_COMP_ALL_PHOTOS:
    '/api/v1/property/compTool/getCompAllPhotos',
  GET_COMP_ALL_PHOTOS_PER_DATE:
    '/api/v1/property/compTool/getCompAllPhotosImagesPerDate'
}


export class CompToolPhotosService extends Service {

  getCompAllPhotos(mlsId: number) {
    return this.get(`${url.GET_COMP_ALL_PHOTOS}?mlsId=${mlsId}`);
  }

  getCompAllPhotosImagesPerDate(property_id: number) {
    return this.get(`${url.GET_COMP_ALL_PHOTOS_PER_DATE}?propertyId=${property_id}`);
  }

}